import React, { Component, Fragment, createRef } from "react";
import ReactTooltip from "react-tooltip";
import Axios from "axios";
import { Form, Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import Loader from "react-loader-spinner";
import { isRequiredSelection } from "./helpers/Validation";
import { useWindowDimensions } from "./hooks/dimensionDetection";
//import {resultBackgroundImage} from '../../assets/images/photo-heart-hcp-cost.png';
//import {resultBackgroundImage} from '../assets/images/graphic-balloon-blue.png';

class InsuranceCoverageLookup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            states: null,
            loadingHealthPlans: false,
            submitted: true,
            coverageType: null,
            healthPlansAvailable: null,
            drugSelection: 4636,
            healthPlan: null,
            healthPlanList: null,
            loadingHealthPlans: false,
            loadingStates: false,
            stateId: null,
            //userCoverage: "yes",
            userCoverage: false,
            healthPlanName: null,
            insurancePlan: "Plan Name",
            insurancePlansAvailable: null,
            insuranceError: false,
            stateError: false,
            insurancePlanError: false,
        };

        this.baseState = this.state;
    }

    updateHiddenInput = (name, value, event = null) => {
        this.setState({
            ...this.state,
            [name]: value,
        });
    };

    getStates = async () => {
        const reactState = this;
        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }
        reactState.setState({
            loadingStates: true,
        });
        await Axios({
            method: "post",
            headers: {
                "Content-type": "application/x-www-form-urlencoded",
            },
            url: url + "api/third_party",
            data: "https://api.fingertipformulary.com/states.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e",
        }).then(function (res) {
            let stateList = [];
            const states = new Promise((resolve, reject) => {
                {
                    res.data.map((state, index) => stateList.push(state.state));
                }
                resolve();
            });
            states.then(() => {
                reactState.setState({
                    states: stateList,
                    loadingStates: false,
                });
            });
        });
    };

    getInsurancePlans = async (stateId) => {
        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }
        let insurancePlans;
        const reactState = this;
        const { coverageType } = this.state;
        this.setState({
            ...this.state,
            loadingHealthPlans: true,
        });
        switch (coverageType) {
            case "I have commercial insurance":
                insurancePlans = "1,4,6,13,9,14,11";
                break;
            case "I have government insurance":
                insurancePlans = "15,8,19,17,5,6,7,18,3,10";
                break;
            default:
                break;
        }

        await Axios({
            method: "post",
            url: url + "api/third_party",
            data:
                "https://api.fingertipformulary.com/health_plans.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e&state_id=" +
                stateId +
                "&health_plan_types=" +
                insurancePlans,
        }).then(function (res) {
            reactState.setState({
                ...reactState,
                stateId: stateId,
                insurancePlansAvailable: res.data,
                loadingHealthPlans: false,
            });
        });
    };

    isUserCovered = async (values) => {
        const { coverageType } = this.state;
        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }

        if (values.insurancePlan === "" || values.insurancePlan === false) {
            // We can't fully submit until we have all values
            if (coverageType !== "I don't have insurance") return;
        }
        // If the user has no insurance
        if (coverageType === "I don't have insurance") {
            this.setState({
                userCoverage: "no-insurance",
                submitted: true,
            });
        } else {
            // Insurance of some kind - continue
            const reactState = this;
            const { drugSelection, insurancePlan } = values;
            // To avoid overusing setstate ID & name are barrelled
            let insurancePlanId = insurancePlan.split("|")[0];
            let insurancePlanName = insurancePlan.split("|")[1];
            await Axios({
                method: "post",
                url: url + "api/third_party",
                data:
                    "https://api.fingertipformulary.com/coverage_statuses/status.json?api_key=52e319e3b99820fd30a60c254578f76f4d923e9e&drug_id=" +
                    drugSelection +
                    "&plan_ids=" +
                    insurancePlanId,
            }).then(function (res) {
                // determine if user is covered
                let covered;
                console.log("res.data is user covered", res.data[0]);
                res.data.filter((result) => {
                    if (
                        result.formulary_detail.pharmacy_status ===
                        "Not Covered"
                    ) {
                        covered = "no";
                    } else {
                        covered = "yes";
                    }
                    reactState.setState({
                        userCoverage: covered,
                        insurancePlanName: insurancePlanName,
                        submitted: true,
                    });
                    return;
                });
            });
        }
    };

    handleChange = (event) => {
        console.log(event);
        const { name, value } = event.target;
        this.setState({
            InsuranceCoverageLookupItems: {
                [name]: value,
            },
        });
    };

    resetForm = (form) => {
        this.setState(this.baseState);
        this.toTop.current.scrollIntoView({ behavior: "smooth" });
        return form.reset();
    };

    toTop = createRef();

    render() {
        // We can refactor this if it is used in more than one place in future
        const Tooltip = () => {
            const { width } = useWindowDimensions();
            return (
                <ReactTooltip
                    id="registerTip"
                    className="acadia-tooltip"
                    data-html={true}
                    place={width > "767" ? "right" : "bottom"}
                    effect="solid"
                >
                    <p>
                        <strong>Commercial insurance</strong> or private
                        insurance comes from your employer or a healthcare
                        exchange.
                    </p>
                    <p>
                        <strong>Government insurance</strong> includes Medicare,
                        Medicaid, and insurance from other government programs.
                    </p>
                </ReactTooltip>
            );
        };
        const {
            states,
            submitted,
            insurancePlanName = "plan name goes here",
            coverageType,
            insurancePlansAvailable,
            userCoverage,
            drugSelection,
            loadingHealthPlans,
            loadingStates,
        } = this.state;
        const largeCapsules = 4636;

        return (
            <div className="grid acadia-form m-1" ref={this.toTop}>
                <div className="row spacer-medium">&nbsp;</div>
                <div id="formTop">
                    <Form onSubmit={this.isUserCovered}>
                        {({
                            form,
                            values,
                            pristine,
                            submitting,
                            handleSubmit,
                        }) => (
                            <form>
                                <div className="form-group">
                                    {!drugSelection && (
                                        <Fragment>
                                            <div className="row text-center">
                                                <div className="col-sm-6 ">
                                                    <div
                                                        className="round-area mb-3 drug-selection"
                                                        onClick={(e) =>
                                                            this.updateHiddenInput(
                                                                "drugSelection",
                                                                largeCapsules
                                                            )
                                                        }
                                                    >
                                                        <h6>
                                                            NUPLAZID<sup>®</sup>{" "}
                                                            (PIMAVANSERIN)
                                                        </h6>
                                                        <p>34 MG CAPSULES</p>
                                                        <div className="row spacer-xsmall">
                                                            &nbsp;
                                                        </div>
                                                        <button
                                                            className="button white"
                                                            type="button"
                                                            id="gtm-insurance-coverage-form-select"
                                                        >
                                                            SELECT
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                    )}

                                    {drugSelection && (
                                        <div className="row">
                                            <div className="col-lg-4 col-sm-7">
                                                <Field
                                                    className="form-control full-width-input"
                                                    name="drugSelection"
                                                    component="input"
                                                    type="hidden"
                                                    defaultValue={drugSelection}
                                                    validate={
                                                        isRequiredSelection
                                                    }
                                                />
                                                <div className="form-group">
                                                    <Field
                                                        name="coverageType"
                                                        component="select"
                                                        defaultValue=""
                                                        className="select-css"
                                                        validate={
                                                            isRequiredSelection
                                                        }
                                                    >
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label
                                                                    className={
                                                                        "full-width-label text-left "
                                                                    }
                                                                >
                                                                    <span
                                                                        className={
                                                                            "hang-left-6"
                                                                        }
                                                                    >
                                                                        *
                                                                    </span>
                                                                    Indicates
                                                                    required
                                                                    field.
                                                                </label>
                                                                <label
                                                                    className={
                                                                        "full-width-label text-left " +
                                                                        (meta.error &&
                                                                        meta.touched
                                                                            ? "error"
                                                                            : "")
                                                                    }
                                                                >
                                                                    Select
                                                                    insurance
                                                                    status*{" "}
                                                                    <span
                                                                        className="information-tooltip"
                                                                        data-tip
                                                                        data-for="registerTip"
                                                                    >
                                                                        ?
                                                                    </span>
                                                                    <Tooltip />
                                                                </label>
                                                                <select
                                                                    {...input}
                                                                    className="select-css"
                                                                >
                                                                    <option
                                                                        name="coverageType"
                                                                        defaultValue=""
                                                                    >
                                                                        Select
                                                                    </option>
                                                                    <option
                                                                        name="coverageType"
                                                                        defaultValue="I have commercial insurance"
                                                                    >
                                                                        I have
                                                                        commercial
                                                                        insurance
                                                                    </option>
                                                                    <option
                                                                        name="coverageType"
                                                                        defaultValue="I have government insurance"
                                                                    >
                                                                        I have
                                                                        government
                                                                        insurance
                                                                    </option>
                                                                    <option
                                                                        name="coverageType"
                                                                        defaultValue="I don't have insurance"
                                                                    >
                                                                        I don't
                                                                        have
                                                                        insurance
                                                                    </option>
                                                                </select>
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                    <div className="row spacer-medium" />
                                                    <OnChange name="coverageType">
                                                        {(value, previous) => {
                                                            // This ensures the user resets if they randomly
                                                            // pass this point then change states again
                                                            form.change(
                                                                "stateId",
                                                                ""
                                                            );
                                                            form.change(
                                                                "insurancePlan",
                                                                ""
                                                            );
                                                            this.setState({
                                                                coverageType:
                                                                    value,
                                                                insurancePlansAvailable: false, // Reset health plans if the user changes coverage
                                                            });
                                                            this.getStates();
                                                        }}
                                                    </OnChange>
                                                    {coverageType !==
                                                        "I don't have insurance" && (
                                                        <Fragment>
                                                            <div className="relative">
                                                                <Field
                                                                    name="stateId"
                                                                    component="select"
                                                                    className="select-css"
                                                                    defaultValue=""
                                                                    validate={
                                                                        isRequiredSelection
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <label
                                                                                className={
                                                                                    "full-width-label text-left " +
                                                                                    (meta.error &&
                                                                                    meta.touched
                                                                                        ? "error"
                                                                                        : "")
                                                                                }
                                                                            >
                                                                                Select
                                                                                your
                                                                                state*
                                                                            </label>
                                                                            <select
                                                                                {...input}
                                                                                className="select-css"
                                                                                disabled={
                                                                                    !states
                                                                                }
                                                                            >
                                                                                <option
                                                                                    name="stateId"
                                                                                    defaultValue=""
                                                                                >
                                                                                    Select
                                                                                </option>
                                                                                {states &&
                                                                                    states.map(
                                                                                        (
                                                                                            state,
                                                                                            index
                                                                                        ) => {
                                                                                            return (
                                                                                                <option
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                    name="stateId"
                                                                                                    value={
                                                                                                        state.id
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        state.name
                                                                                                    }
                                                                                                </option>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </select>
                                                                            {loadingStates && (
                                                                                <Loader
                                                                                    type="ThreeDots"
                                                                                    color="#5FA5BB"
                                                                                    height={
                                                                                        100
                                                                                    }
                                                                                    width={
                                                                                        100
                                                                                    }
                                                                                    className="loading-icon insurance-lookup-state"
                                                                                />
                                                                            )}
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                            <div className="row spacer-medium" />
                                                            <OnChange name="stateId">
                                                                {(
                                                                    value,
                                                                    previous
                                                                ) => {
                                                                    form.change(
                                                                        "insurancePlan",
                                                                        ""
                                                                    );
                                                                    this.getInsurancePlans(
                                                                        value
                                                                    );
                                                                }}
                                                            </OnChange>

                                                            <div className="relative">
                                                                <Field
                                                                    name="insurancePlan"
                                                                    component="select"
                                                                    className="select-css"
                                                                    defaultValue=""
                                                                    validate={
                                                                        isRequiredSelection
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <label
                                                                                className={
                                                                                    "full-width-label text-left " +
                                                                                    (meta.error &&
                                                                                    meta.touched
                                                                                        ? "error"
                                                                                        : "")
                                                                                }
                                                                            >
                                                                                Select
                                                                                insurance
                                                                                plan*
                                                                            </label>
                                                                            <select
                                                                                {...input}
                                                                                className="select-css"
                                                                                disabled={
                                                                                    !insurancePlansAvailable
                                                                                }
                                                                            >
                                                                                <option
                                                                                    name="insurancePlan"
                                                                                    defaultValue=""
                                                                                >
                                                                                    Select
                                                                                </option>
                                                                                {insurancePlansAvailable &&
                                                                                    insurancePlansAvailable.map(
                                                                                        (
                                                                                            item,
                                                                                            index
                                                                                        ) => {
                                                                                            const {
                                                                                                displayid,
                                                                                                webname,
                                                                                            } =
                                                                                                item.health_plan;
                                                                                            return (
                                                                                                <option
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                    name="insurancePlan"
                                                                                                    value={
                                                                                                        displayid +
                                                                                                        "|" +
                                                                                                        webname
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        webname
                                                                                                    }
                                                                                                </option>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </select>
                                                                            {loadingHealthPlans && (
                                                                                <Loader
                                                                                    type="ThreeDots"
                                                                                    color="#5FA5BB"
                                                                                    height={
                                                                                        100
                                                                                    }
                                                                                    width={
                                                                                        100
                                                                                    }
                                                                                    className="loading-icon"
                                                                                />
                                                                            )}
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        </Fragment>
                                                    )}
                                                </div>
                                                {drugSelection && (
                                                    <div className="text-left">
                                                        <div className="row spacer-medium">
                                                            &nbsp;
                                                        </div>
                                                        {/*<button type="button" onClick={(form) => this.resetForm(form)} className="button blue button-spacing back" disabled={loadingHealthPlans || submitting || pristine}>
                                                        <span>
                                                            <svg width="0.9em" height="0.9em" viewBox="0 0 16 16" className="bi bi-chevron-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                                            </svg>
                                                        </span>
                                                        Previous step
                                                    </button>*/}
                                                        <button
                                                            type="submit"
                                                            onClick={
                                                                handleSubmit
                                                            }
                                                            id="gtm-insurance-coverage-results-button"
                                                            className={
                                                                "button blue button-spacing insurance-lookup relative forward " +
                                                                (submitting
                                                                    ? "loading"
                                                                    : "")
                                                            }
                                                            disabled={
                                                                loadingHealthPlans ||
                                                                submitting
                                                            }
                                                        >
                                                            GET RESULTS
                                                            {submitting && (
                                                                <Loader
                                                                    type="ThreeDots"
                                                                    color="#FFF"
                                                                    height={100}
                                                                    width={100}
                                                                    className="loading-icon insurance-lookup-coverage-results-button"
                                                                />
                                                            )}
                                                        </button>
                                                        <div className="row spacer-small" />
                                                        <p className="thisinform">
                                                            This information is
                                                            provided as a guide.
                                                            Actual coverage and
                                                            costs may differ
                                                            between private and
                                                            government insurance
                                                            plans, and are
                                                            subject to change.
                                                            Please check with
                                                            the health plan to
                                                            confirm coverage.
                                                        </p>
                                                        <div className="row spacer-large mobile" />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-7 offset-lg-1 col-sm-7">
                                                {!userCoverage && (
                                                    <Fragment>
                                                        <div class="text-right-lg">
                                                            <img
                                                                src="/images/insurance-coverage-lookup-background.jpg"
                                                                className="desktop-inline-block"
                                                            />
                                                            <img
                                                                src="/images/insurance-coverage-lookup-background-mb@2x.jpg"
                                                                className="mobile-inline-block mw-320"
                                                            />
                                                        </div>
                                                    </Fragment>
                                                )}

                                                {userCoverage === "yes" &&
                                                    submitted && (
                                                        <Fragment>
                                                            <div className="result">
                                                                <p className="font-20 medium-font blue-font">
                                                                    GREAT NEWS!
                                                                </p>
                                                                <p className="font-20">
                                                                    It looks
                                                                    like{" "}
                                                                    {
                                                                        insurancePlanName
                                                                    }{" "}
                                                                    covers your
                                                                    prescription.{" "}
                                                                    <br className="desktop" />
                                                                    {coverageType ==
                                                                        "I have commercial insurance" && (
                                                                        <Fragment>
                                                                            You
                                                                            might
                                                                            qualify
                                                                            for
                                                                            a $0
                                                                            co-pay.
                                                                            <sup className="dagger">
                                                                                <span>
                                                                                    &dagger;
                                                                                </span>
                                                                            </sup>
                                                                        </Fragment>
                                                                    )}
                                                                    {coverageType ==
                                                                        "I have government insurance" && (
                                                                        <Fragment>
                                                                            You
                                                                            may
                                                                            be
                                                                            able
                                                                            to
                                                                            pay{" "}
                                                                            <b>
                                                                                less
                                                                                than
                                                                                $10
                                                                            </b>{" "}
                                                                            for
                                                                            your
                                                                            prescription.
                                                                            <sup className="dagger">
                                                                                <span>
                                                                                    &dagger;
                                                                                </span>
                                                                            </sup>
                                                                        </Fragment>
                                                                    )}
                                                                </p>
                                                                <p>
                                                                    <a href="/nuplazid/patient-caregivers/enrollment">
                                                                        Enroll
                                                                        in
                                                                        Acadia
                                                                        Connect
                                                                    </a>
                                                                    <span className="trade">
                                                                        &reg;
                                                                    </span>{" "}
                                                                    to get
                                                                    started. If
                                                                    you’re
                                                                    already
                                                                    enrolled and
                                                                    have
                                                                    questions,
                                                                    connect with
                                                                    your Care
                                                                    Coordinator
                                                                    at{" "}
                                                                    <a
                                                                        href="tel:+18447372223"
                                                                        className="no-underline nobr"
                                                                    >
                                                                        1-844-737-2223
                                                                    </a>
                                                                    , Monday
                                                                    through
                                                                    Friday, 8:00
                                                                    am-8:00 pm
                                                                    ET.
                                                                </p>
                                                                <div className="row spacer-xsmall" />
                                                                <a
                                                                    href="/nuplazid/patient-caregivers/enrollment"
                                                                    className={
                                                                        "button blue button-spacing insurance-lookup relative forward"
                                                                    }
                                                                >
                                                                    ENROLL NOW
                                                                </a>
                                                                <div className="row spacer-medium" />
                                                                {coverageType ==
                                                                    "I have commercial insurance" && (
                                                                    <p className="thisinform">
                                                                        <sup className="dagger">
                                                                            <span className="hang-left-2">
                                                                                &dagger;
                                                                            </span>
                                                                        </sup>
                                                                        Acadia&nbsp;Connect{" "}
                                                                        <a
                                                                            className="terms-and-conditions"
                                                                            target="_blank"
                                                                            href="/nuplazid/pdf/program-details-and-patient-eligibility.pdf"
                                                                        >
                                                                            patient
                                                                            eligibility
                                                                            and
                                                                            terms
                                                                            and
                                                                            conditions
                                                                        </a>{" "}
                                                                        apply.
                                                                    </p>
                                                                )}
                                                                {coverageType ==
                                                                    "I have government insurance" && (
                                                                    <p className="thisinform">
                                                                        <sup className="dagger">
                                                                            <span className="hang-left-6">
                                                                                &dagger;
                                                                            </span>
                                                                        </sup>
                                                                        Around
                                                                        10% of
                                                                        patients
                                                                        may pay
                                                                        more
                                                                        than $10
                                                                        for
                                                                        their
                                                                        prescription.
                                                                        As
                                                                        reported
                                                                        by four
                                                                        specialty
                                                                        pharmacy
                                                                        organizations;
                                                                        Q1 to Q2
                                                                        2023
                                                                        data.
                                                                    </p>
                                                                )}
                                                                <div
                                                                    className="row spacer-medium"
                                                                    ref={
                                                                        this
                                                                            .toTop
                                                                    }
                                                                >
                                                                    &nbsp;
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                    )}

                                                {userCoverage === "no" &&
                                                    submitted && (
                                                        <Fragment>
                                                            <div className="result">
                                                                <p className="font-20 medium-font blue-font uppercase">
                                                                    {
                                                                        insurancePlanName
                                                                    }{" "}
                                                                    does not
                                                                    cover your
                                                                    prescription.
                                                                </p>
                                                                <p className="font-20">
                                                                    But don’t
                                                                    worry, there
                                                                    are still
                                                                    options
                                                                    available.
                                                                </p>
                                                                <p>
                                                                    <a href="/patient-caregivers/enrollment-short">
                                                                        Enroll
                                                                        in
                                                                        Acadia
                                                                        Connect
                                                                    </a>
                                                                    <span className="trade">
                                                                        &reg;
                                                                    </span>{" "}
                                                                    to learn
                                                                    more. If
                                                                    you’re
                                                                    already
                                                                    enrolled and
                                                                    have
                                                                    questions,
                                                                    connect with
                                                                    your Care
                                                                    Coordinator
                                                                    at{" "}
                                                                    <a
                                                                        href="tel:+18447372223"
                                                                        className="no-underline nobr"
                                                                    >
                                                                        1-844-737-2223
                                                                    </a>
                                                                    , Monday
                                                                    through
                                                                    Friday, 8:00
                                                                    am-8:00 pm
                                                                    ET.
                                                                </p>
                                                                <div className="row spacer-xsmall" />
                                                                {/*<a href="/patient-caregivers/enrollment-short" className={"button blue button-spacing insurance-lookup relative forward"}>ENROLL NOW</a>*/}
                                                            </div>
                                                        </Fragment>
                                                    )}

                                                {userCoverage ===
                                                    "no-insurance" &&
                                                    submitted && (
                                                        <Fragment>
                                                            <div className="result">
                                                                <p className="font-20 medium-font blue-font">
                                                                    WE CAN HELP
                                                                </p>
                                                                <p>
                                                                    If you can’t
                                                                    afford your
                                                                    prescription,
                                                                    there are
                                                                    financial
                                                                    assistance
                                                                    programs
                                                                    available
                                                                    you might
                                                                    qualify for,
                                                                    like the
                                                                    Acadia
                                                                    Connect
                                                                    <span className="trade">
                                                                        &reg;
                                                                    </span>{" "}
                                                                    &nbsp;Patient
                                                                    Assistance
                                                                    Program.
                                                                </p>
                                                                <p>
                                                                    <b>
                                                                        You
                                                                        might be
                                                                        able to
                                                                        get your
                                                                        prescription
                                                                        for $0
                                                                        per
                                                                        month.
                                                                    </b>
                                                                </p>
                                                                <p>
                                                                    <a href="/patient-caregivers/enrollment-short">
                                                                        Enroll
                                                                        in
                                                                        Acadia
                                                                        Connect
                                                                    </a>{" "}
                                                                    to learn
                                                                    more. If
                                                                    you’re
                                                                    already
                                                                    enrolled and
                                                                    have
                                                                    questions,
                                                                    connect with
                                                                    your Care
                                                                    Coordinator
                                                                    at{" "}
                                                                    <a
                                                                        href="tel:+18447372223"
                                                                        className="no-underline nobr"
                                                                    >
                                                                        1-844-737-2223
                                                                    </a>
                                                                    , Monday
                                                                    through
                                                                    Friday, 8:00
                                                                    am-8:00 pm
                                                                    ET.
                                                                </p>
                                                            </div>
                                                        </Fragment>
                                                    )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {process.env.NODE_ENV === "development" && (
                                    <pre
                                        style={{
                                            marginTop: "50px",
                                            marginBottom: "50px",
                                        }}
                                    >
                                        {JSON.stringify(values, 0, 2)}
                                    </pre>
                                )}
                            </form>
                        )}
                    </Form>
                </div>
            </div>
        );
    }
}

export default InsuranceCoverageLookup;
